<template>
  <section>
    <section class="rankingRules-popup-wrapper">
      <div
        class="close-wrapper"
        @click="showSwitch"
        :style="{ background: 'rgba(0,0,0,0)' }"
        v-if="showPopup"
      >
        <span class="iconfont icon-cancel"></span>
      </div>
      <van-popup
        v-model="showPopup"
        :style="{
          height: isDesktop ? '800px' : '72%',
          width: isDesktop ? '400px' : '92%',
        }"
        round
        class="rankingRules-popup"
        :close-on-click-overlay="false"
      >
        <section class="rules-body-container">
          <div class="safe-area top"></div>
          <div v-html="html"></div>
          <div class="safe-area bottom"></div>
        </section>
      </van-popup>
    </section>
  </section>
</template>
<script>
  import { getAcitivityInfo } from '../helper'
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        showPopup: false,
        html: '',
      }
    },
    computed: {
      ...mapState(['isDesktop']),
    },
    watch: {
      showPopup(newVal) {
        if (!newVal) {
          this.$emit('rulePopupIsClose')
        } else {
          getAcitivityInfo().then((res = {}) => {
            const { extraInfo = {} } = res
            this.html = extraInfo.rule || ''
          })
          this.setInputDisabled()
        }
      },
    },
    mounted() {},
    methods: {
      showSwitch() {
        this.showPopup = !this.showPopup
      },
      openPopup() {
        this.showPopup = true
      },
      clickPopup() {
        this.showPopup = false
      },
      setInputDisabled() {
        if (!process.client) {
          return
        }
        const timeid = setTimeout(() => {
          const inputs =
            document.querySelectorAll('.rules-body-container input') || []
          const textareas =
            document.querySelectorAll('.rules-body-container textarea') || []
          Array.from(inputs).forEach((node) => {
            node.setAttribute('disabled', true)
          })
          Array.from(textareas).forEach((node) => {
            node.setAttribute('disabled', true)
          })
          clearTimeout(timeid)
        }, 200)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .rankingRules-popup-wrapper {
    .rankingRules-popup.van-popup {
      background-color: transparent;
    }
    .close-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: fixed;
      right: 20px;
      top: 9%;
      z-index: 3000;
      .iconfont {
        color: #fff;
        font-size: 100px;
      }
    }
  }
  .rules-body-container {
    position: relative;
    .safe-area {
      position: sticky;
      left: 0;
      top: 0;
      width: 100%;
      height: 96px;
      background: #fff;
      &.bottom {
        top: unset;
        bottom: 0;
      }
    }
    overflow-y: scroll;
    padding: 0px 48px;
    box-sizing: border-box;
    overflow-x: hidden;
    background: #fff;
    width: 100%;
    height: 100%;
    font-family: 'MiSans';
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 60px;
    color: #000000;
    overflow-x: hidden;
  }
</style>
<style>
  .rankingRules-popup-wrapper table {
    word-wrap: break-word;
    word-break: break-all;
    table-layout: fixed;
    width: 100% !important;
  }
  .rankingRules-popup-wrapper table td {
    width: 100% !important;
  }
  .rankingRules-popup-wrapper table tr:first-child {
    background: #ccd7ff;
  }
  .rankingRules-popup-wrapper .rules-body-container p {
    margin-bottom: 20px !important;
  }
  .rankingRules-popup-wrapper .rules-body-container p:last-child {
    margin-bottom: 0px !important;
  }
  .rankingRules-popup-wrapper .rules-body-container p,
  .rankingRules-popup-wrapper .rules-body-container div {
    white-space: unset !important;
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    .rankingRules-popup-wrapper {
      .close-wrapper {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: fixed;
        right: 36%;
        top: 9%;
        z-index: 3000;
        cursor: pointer;
        .iconfont {
          color: #999;
          font-size: 50px;
        }
      }
    }

    .rules-body-container {
      background: #fff;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      padding: 32px 16px;
      box-sizing: border-box;
      font-family: 'MiSans';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 1.3;
      color: #000000;
      overflow-x: hidden;
    }
  }
</style>
<style>
  @media screen and (min-device-width: 1080px) {
    .rankingRules-popup-wrapper .rankingRules-popup .rules-body-container p {
      margin-bottom: 20px !important;
    }
  }
</style>
